export const NO_RESULT_PLACEHOLDER = {
    searchCardNoResults: {
        title: 'Sorry, no results',
        description: '',
        imageUrl: '/images/no-search-result.svg',
    },
    searchCardNoSuggestionConfig: {
        title: 'Please use keyboard to search for Destination and Experiences',
        description: '',
        imageUrl: '/images/no-search-result.svg',
    },
    event: {
        title: 'Sorry, no results',
        description: '',
        imageUrl: '/images/no-event-result.svg',
    },
    tenants: {
        title: 'Sorry, no results',
        description: '',
        imageUrl: '/images/no-tenant-result.svg',
    },
    promotions: {
        title: 'Sorry, no results',
        description: '',
        imageUrl: '/images/no-promo-result.svg',
    },
};
